import type { ReactNode } from "react";
import { Box, Button } from "@mui/material";
import LessonInfo from "./LessonInfo";
import LessonSidebar from "./LessonSidebar";
import { ArrowBackIos } from "@mui/icons-material";
import { Lesson } from "./ArticleReader";

interface CourseLayoutProps {
  children: ReactNode;
  currentLesson: Lesson;
  currentLessonIndex: number;
  totalLessons: number;
  lessons: Lesson[];
  progress: number;
  nextLesson: Lesson | null;
  onNext: () => void;
  onPrevious: () => void;
  onSelectLesson: (index: number) => void;
  onBack: () => void;
}

export default function CourseLayout({
  children,
  currentLesson,
  currentLessonIndex,
  totalLessons,
  lessons,
  progress,
  nextLesson,
  onNext,
  onPrevious: _onPrevious,
  onSelectLesson,
  onBack,
}: CourseLayoutProps) {
  void _onPrevious;
  return (
    <Box sx={{ minHeight: "100vh" }}>
      {/* Header with Back Button */}
      <Box sx={{ mb: 3 }}>
        <Button
          sx={{ backgroundColor: "white", borderRadius: "26px" }}
          onClick={onBack}
        >
          <ArrowBackIos /> Back
        </Button>
      </Box>

      {/* Main Content */}

      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexDirection: { xs: "column", lg: "row" },
        }}
      >
        {/* Left Content Area */}
        <Box sx={{ flex: 1, maxWidth: { lg: "65%" } }}>
          {/* Content Player/Reader */}
          {children}

          {/* Lesson Info Section */}
          <LessonInfo
            lesson={currentLesson}
            lessonNumber={currentLessonIndex + 1}
            nextLesson={nextLesson}
            onNext={onNext}
          />
        </Box>

        {/* Right Sidebar */}
        <Box sx={{ width: { xs: "100%", lg: "35%" }, maxWidth: { lg: 400 } }}>
          <LessonSidebar
            lessons={lessons}
            currentLessonIndex={currentLessonIndex}
            totalLessons={totalLessons}
            progress={progress}
            onSelectLesson={onSelectLesson}
          />
        </Box>
      </Box>
    </Box>
  );
}
